/* Panache Atelier — theme scripts (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }

  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var wrap = $('.header-wrap');
    if (!wrap) return;
    var onScroll = function () { wrap.classList.toggle('is-scrolled', window.scrollY > 40 && wrap.classList.contains('is-transparent')); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    $$('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { var bar = $('.search-bar'); if (!bar) return; bar.classList.toggle('is-open'); var i = $('input', bar); if (i && bar.classList.contains('is-open')) i.focus(); });
    });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); document.body.style.overflow = 'hidden'; d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert');
    var f = $('button, a, input', d); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) { d.classList.remove('is-open'); document.body.style.overflow = ''; d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', ''); }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open-drawer]');
      if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
      var c = e.target.closest('[data-close-drawer]');
      if (c) { var d = c.closest('.drawer'); if (d) closeDrawer(d); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });
  }

  /* ---------- Announcement ---------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('.announcement__item', bar); if (items.length < 2) return;
      var i = 0; setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4500);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    refresh: function (open) {
      return fetch(window.theme.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer']; if (!html) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = $('#CartDrawer', tmp), cur = $('#CartDrawer');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
          return fetch(window.theme.routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart) $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
          if (open) openDrawer('CartDrawer');
        });
    },
    add: function (items) {
      return fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    syncAddons: function () {
      return fetch(window.theme.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (c) {
        var byGroup = {}, byTitle = {}, upd = {}, n = 0;
        c.items.forEach(function (it) { var p = it.properties || {}; if (p._for) return; if (p._group) byGroup[p._group] = (byGroup[p._group] || 0) + it.quantity; byTitle[it.product_title] = (byTitle[it.product_title] || 0) + it.quantity; });
        c.items.forEach(function (it) { var p = it.properties || {}; if (!p._for) return; var want = p._group ? (byGroup[p._group] || 0) : (byTitle[p._for] || 0); if (want !== it.quantity) { upd[it.key] = want; n++; } });
        if (!n) return c;
        return fetch(window.theme.routes.cart_url + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function (r) { return r.json(); });
      });
    },
    change: function (key, qty) {
      return fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };
  window.PanacheCart = Cart;

  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (btn) {
        var key = btn.getAttribute('data-key'), q = parseInt(btn.getAttribute('data-cart-qty'), 10);
        btn.disabled = true;
        Cart.change(key, q).then(function () { return Cart.syncAddons(); }).then(function () { return Cart.refresh(false); }).then(function () {
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
      }
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]'); if (!b) return;
      var input = $('input', b.closest('.qty')); if (!input) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Form → cart items ---------- */
  function collectProperties(form) {
    var props = {};
    $$('[name^="properties["]', form).forEach(function (el) {
      if (el.disabled) return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var v = (el.value || '').trim(); if (!v) return;
      var k = el.name.slice(11, -1);
      props[k] = v;
    });
    if (!props.Monogram) { delete props['Monogram colour']; delete props['Monogram position']; }
    if (props.Sizing === 'Standard size') { delete props.Unit; }
    return props;
  }

  function validate(scope) {
    var ok = true, first = null;
    $$('[data-required]', scope).forEach(function (el) {
      if (el.disabled || el.closest('[hidden]')) return;
      var bad;
      if (el.type === 'radio') { bad = !$$('input[name="' + el.name + '"]', scope).some(function (r) { return r.checked; }); }
      else { bad = !(el.value || '').trim(); }
      var host = el.closest('.field') || el.closest('.option-group');
      if (host) host.classList.toggle('has-error', bad);
      if (bad) { ok = false; if (!first) first = el; }
    });
    if (first) { first.focus({ preventScroll: true }); (first.closest('.field') || first.closest('.option-group') || first).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  /* ---------- Measurements ---------- */
  function initMeasurements(scope) {
    $$('[data-measurements]', scope).forEach(function (box) {
      var unitInput = $('[data-unit-input]', box);
      $$('[data-unit]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-unit]', box).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          if (unitInput) unitInput.value = b.getAttribute('data-unit');
          $$('[data-unit-label]', box).forEach(function (l) { l.textContent = b.getAttribute('data-unit'); });
        });
      });
      var saved = store.get('panache_measurements');
      if (saved) $$('input[data-measure]', box).forEach(function (i) { if (saved[i.getAttribute('data-measure')] && !i.value) i.value = saved[i.getAttribute('data-measure')]; });
      var form = box.closest('form');
      if (form) form.addEventListener('panache:beforeadd', function () {
        var remember = $('[data-remember]', box);
        if (remember && remember.checked) {
          var data = {}; $$('input[data-measure]', box).forEach(function (i) { data[i.getAttribute('data-measure')] = i.value; });
          store.set('panache_measurements', data);
        }
      });
    });
    // sizing method switch (standard vs measurements)
    $$('[data-size-method]', scope).forEach(function (group) {
      var sync = function () {
        var m = ($('input:checked', group) || {}).value;
        var form = group.closest('form') || document;
        $$('[data-measure-fields]', form).forEach(function (f) {
          var on = m === (f.getAttribute('data-measure-fields') || 'My measurements');
          f.hidden = !on;
          $$('input,select,textarea', f).forEach(function (i) { if (!i.hasAttribute('data-always')) i.disabled = !on; });
        });
        $$('[data-measure-any]', form).forEach(function (f) {
          var on = !!m && m !== 'Standard size';
          f.hidden = !on;
          $$('input,select,textarea', f).forEach(function (i) { if (!i.hasAttribute('data-always')) i.disabled = !on; });
        });
        $$('[data-standard-fields]', form).forEach(function (f) {
          var on = !m || m === 'Standard size';
          f.hidden = !on;
          $$('input,select,textarea', f).forEach(function (i) { i.disabled = !on; });
        });
      };
      $$('input', group).forEach(function (r) { r.addEventListener('change', sync); }); sync();
    });
  }

  /* ---------- Monogram ---------- */
  function initMonogram(scope) {
    $$('[data-monogram]', scope).forEach(function (box) {
      var input = $('[data-monogram-input]', box), prev = $('[data-monogram-preview]', box), color = $$('[data-monogram-color]', box);
      var upd = function () {
        if (!prev) return;
        prev.textContent = (input.value || 'ABC').toUpperCase().slice(0, 3);
        var c = color.filter(function (x) { return x.checked; })[0];
        prev.style.color = c ? (c.getAttribute('data-hex') || '') : '';
      };
      if (input) { input.addEventListener('input', function () { input.value = input.value.replace(/[^a-zA-Z.&]/g, '').toUpperCase(); upd(); }); }
      color.forEach(function (c) { c.addEventListener('change', upd); }); upd();
    });
  }

  /* ---------- Option labels ---------- */
  function initOptionLabels(scope) {
    $$('.option-group', scope).forEach(function (g) {
      var out = $('.option-group__value', g); if (!out) return;
      var upd = function () { var c = $('input:checked', g); out.textContent = c ? (c.getAttribute('data-label') || c.value) : ''; };
      g.addEventListener('change', upd); upd();
    });
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root); if (!form) return;
    var jsonEl = $('[data-product-json]', root);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = $('input[name="id"]', form);
    var atc = $('[data-atc]', form), atcText = atc ? $('[data-atc-text]', atc) : null;
    var priceEl = $('[data-price]', root);
    var errorEl = $('.form-error', form);

    // Variant selection
    function currentVariant() {
      if (!product) return null;
      var sel = $$('[data-option-index]', form).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      if (!sel.length) return product.variants[0];
      var sm = $('[data-size-method] input:checked', form);
      if (sm && !sm.disabled && sm.value !== 'Standard size') {
        var cv = product.variants.filter(function (v) { return v.options.every(function (o) { return o === 'Custom'; }); })[0];
        if (cv) return cv;
      }
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
    }
    function onVariant() {
      var v = currentVariant();
      if (!v) { if (atc) atc.disabled = true; if (atcText) atcText.textContent = atc.getAttribute('data-unavailable'); return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = '<span class="price__current">' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<span class="price__compare">' + money(v.compare_at_price) + '</span>' : '');
        priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
      }
      if (atc) { atc.disabled = !v.available; if (atcText) atcText.textContent = v.available ? atc.getAttribute('data-default') : atc.getAttribute('data-soldout'); }
      if (v.featured_media && v.featured_media.id) {
        var m = document.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (m && m.parentNode) { m.parentNode.insertBefore(m, m.parentNode.firstChild); }
      }
      if (history.replaceState && product.variants.length > 1) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    $$('[data-option-index] input', form).forEach(function (i) { i.addEventListener('change', onVariant); });
    $$('[data-size-method] input', form).forEach(function (i) { i.addEventListener('change', onVariant); });

    // Ready / Customize mode
    var modeInputs = $$('[data-mode]', form);
    function syncMode() {
      var m = (modeInputs.filter(function (x) { return x.checked; })[0] || {}).value || 'ready';
      $$('[data-custom-panel]', form).forEach(function (p) {
        var on = m === 'custom'; p.classList.toggle('is-active', on);
        $$('input,select,textarea', p).forEach(function (i) { i.disabled = !on; });
      });
      $$('[data-ready-only]', form).forEach(function (el) { el.hidden = m === 'custom'; });
      var t = $('[data-order-type]', form); if (t) t.value = m === 'custom' ? 'Customized' : 'Ready design';
      if (m === 'custom') { initMeasurementsSync(form); }
    }
    function initMeasurementsSync(f) { $$('[data-size-method] input:checked', f).forEach(function (r) { r.dispatchEvent(new Event('change')); }); }
    modeInputs.forEach(function (i) { i.addEventListener('change', syncMode); });
    syncMode();

    initMeasurements(form); initMonogram(form); initOptionLabels(form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.classList.remove('is-visible');
      if (!validate(form)) { if (errorEl) { errorEl.textContent = window.theme.strings.required; errorEl.classList.add('is-visible'); } return; }
      form.dispatchEvent(new CustomEvent('panache:beforeadd'));
      var qty = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
      var props = collectProperties(form);
      var items = [{ id: parseInt(idInput.value, 10), quantity: qty, properties: props }];
      $$('[data-addon]', form).forEach(function (a) {
        var trigger = a.getAttribute('data-addon-when');
        var trig = trigger ? $(trigger, form) : null;
        if (trig && !trig.disabled && (trig.value || '').trim() && ((trig.type !== 'checkbox' && trig.type !== 'radio') || trig.checked)) {
          items.push({ id: parseInt(a.getAttribute('data-addon'), 10), quantity: qty, properties: { _for: (product ? product.title : '') } });
        }
      });
      if (atc) atc.classList.add('is-loading');
      Cart.add(items).then(function () {
        if (window.theme.cartDrawer) return Cart.refresh(true);
        window.location.href = window.theme.routes.cart_url;
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || window.theme.strings.error; errorEl.classList.add('is-visible'); }
      }).then(function () { if (atc) atc.classList.remove('is-loading'); });
    });

    // Gallery zoom
    $$('.product__img', root).forEach(function (m) { m.addEventListener('click', function () { if (window.innerWidth > 900) m.classList.toggle('is-zoomed'); }); });

    // Sticky add to cart
    var sticky = $('.sticky-atc');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var sv = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-visible', sv); sticky.setAttribute('aria-hidden', sv ? 'false' : 'true'); if (sv) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); } }).observe(atc);
      var sb = $('button', sticky); if (sb) sb.addEventListener('click', function () { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  /* ---------- Fully custom builder ---------- */
  function initBuilder(root) {
    var form = $('[data-builder]', root); if (!form) return;
    var steps = $$('.builder__step', form), tabs = $$('.builder__progress button', root);
    var cur = 0;
    var prevBtn = $('[data-prev]', form), nextBtn = $('[data-next]', form), addBtn = $('[data-atc]', form);
    var product = JSON.parse(($('[data-product-json]', root) || { textContent: 'null' }).textContent);
    var idInput = $('input[name="id"]', form);
    var errorEl = $('.form-error', form);

    function show(n) {
      cur = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
      tabs.forEach(function (t, i) { t.classList.toggle('is-current', i === cur); t.classList.toggle('is-done', i < cur); });
      if (prevBtn) prevBtn.style.visibility = cur === 0 ? 'hidden' : 'visible';
      if (nextBtn) nextBtn.hidden = cur === steps.length - 1;
      if (addBtn) addBtn.hidden = cur !== steps.length - 1;
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { show(cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (validate(steps[cur])) show(cur + 1); });
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { if (i <= cur || validate(steps[cur])) show(i); }); });

    function summary() {
      var list = $('[data-summary-list]', root); if (!list) return;
      var html = '';
      $$('[data-summary]', form).forEach(function (g) {
        var label = g.getAttribute('data-summary'), val = '';
        var mono = $('[data-monogram-input]', g);
        var c = $('input:checked', g);
        if (mono) { val = mono.value ? mono.value + (c ? ' · ' + (c.getAttribute('data-label') || c.value) : '') : ''; }
        else if (c) val = c.getAttribute('data-label') || c.value;
        else { var t = $('input[type=text],select', g); if (t && !t.disabled) val = t.value; }
        if (val) html += '<dt>' + label + '</dt><dd>' + val.replace(/</g, '&lt;') + '</dd>';
      });
      list.innerHTML = html;
      var tier = $('[data-tier]:checked', form);
      if (tier && product) {
        var v = product.variants.filter(function (x) { return String(x.id) === tier.value; })[0];
        if (v) { if (idInput) idInput.value = v.id; var tot = $('[data-summary-total]', root); if (tot) tot.textContent = money(v.price); }
      }
      var fab = $('[data-fabric]:checked', form), img = $('[data-summary-image]', root);
      if (fab && img && fab.getAttribute('data-image')) { img.src = fab.getAttribute('data-image'); img.hidden = false; }
      var shirt = $('[data-summary-shirt] path', root);
      if (fab && shirt && !fab.getAttribute('data-image') && fab.getAttribute('data-color')) { shirt.setAttribute('fill', fab.getAttribute('data-color')); }
    }
    form.addEventListener('change', summary); form.addEventListener('input', summary);
    initMeasurements(form); initMonogram(form); initOptionLabels(form);
    summary(); show(0);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) { if (errorEl) { errorEl.textContent = window.theme.strings.required; errorEl.classList.add('is-visible'); } return; }
      form.dispatchEvent(new CustomEvent('panache:beforeadd'));
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1, properties: collectProperties(form) }];
      $$('[data-addon]', form).forEach(function (a) {
        var trig = $(a.getAttribute('data-addon-when'), form);
        if (trig && !trig.disabled && (trig.value || '').trim() && ((trig.type !== 'checkbox' && trig.type !== 'radio') || trig.checked)) items.push({ id: parseInt(a.getAttribute('data-addon'), 10), quantity: 1, properties: { _for: 'Fully Custom Shirt' } });
      });
      if (addBtn) addBtn.classList.add('is-loading');
      Cart.add(items).then(function () { return Cart.refresh(true); })
        .catch(function (err) { if (errorEl) { errorEl.textContent = (err && err.description) || window.theme.strings.error; errorEl.classList.add('is-visible'); } })
        .then(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Quick add from cards ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-add]'); if (!b) return;
      e.preventDefault(); b.classList.add('is-loading');
      Cart.add([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }])
        .then(function () { return Cart.refresh(true); })
        .catch(function () { toast(window.theme.strings.error); })
        .then(function () { b.classList.remove('is-loading'); });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $$('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); window.location.href = u.toString(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initDrawers(); initAnnouncement(); initReveal(); initCartDrawer(); initQty(); initQuickAdd(); initSort();
    $$('[data-section-product]').forEach(initProduct);
    $$('[data-section-builder]').forEach(initBuilder);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    $$('[data-section-product]', e.target).forEach(initProduct);
    $$('[data-section-builder]', e.target).forEach(initBuilder);
  });
})();
